import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, Compass, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";

// Guided checklist computed from real data. Can be hidden and shown again.
export const GuidePanel = ({ storageKey, title, steps }) => {
  const [hidden, setHidden] = useState(() => localStorage.getItem(storageKey) === "1");
  const done = steps.filter((s) => s.done).length;
  const pct = steps.length ? Math.round((done / steps.length) * 100) : 0;
  const next = steps.find((s) => !s.done);

  const toggle = (v) => {
    localStorage.setItem(storageKey, v ? "1" : "0");
    setHidden(v);
  };

  if (hidden) {
    return (
      <Button variant="outline" size="sm" onClick={() => toggle(false)} data-testid="guide-show-button">
        <Compass className="h-4 w-4 mr-1" /> Tampilkan panduan
      </Button>
    );
  }
  return (
    <section className="rounded-2xl border bg-card p-6 sist-rise" data-testid="guide-panel">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#3B82F6]">Panduan</p>
          <h2 className="text-base md:text-lg font-bold mt-1">{title}</h2>
        </div>
        <Button variant="ghost" size="icon" onClick={() => toggle(true)} aria-label="Sembunyikan panduan" data-testid="guide-hide-button">
          <X className="h-4 w-4" />
        </Button>
      </div>
      <div className="flex items-center gap-3 mt-4">
        <Progress value={pct} className="h-2" aria-label="Progres panduan" />
        <span className="text-sm font-semibold whitespace-nowrap" data-testid="guide-progress">{done}/{steps.length} selesai</span>
      </div>
      {next && <p className="text-sm mt-4"><span className="font-semibold">Langkah berikutnya:</span> {next.label}</p>}
      <ol className="mt-4 space-y-2">
        {steps.map((s) => (
          <li key={s.key} className="flex items-start gap-3" data-testid={`guide-step-${s.key}`}>
            {s.done ? <CheckCircle2 className="h-5 w-5 text-emerald-600 shrink-0" aria-label="Selesai" /> : <Circle className="h-5 w-5 text-muted-foreground shrink-0" aria-label="Belum selesai" />}
            <div className="flex-1">
              <p className={`text-sm ${s.done ? "text-muted-foreground line-through" : "font-medium"}`}>{s.label}</p>
              {!s.done && s.hint && <p className="text-xs text-muted-foreground">{s.hint}</p>}
            </div>
            {!s.done && s.to && <Link to={s.to} className="text-xs font-semibold text-[#3B82F6] hover:underline" data-testid={`guide-step-link-${s.key}`}>Buka</Link>}
          </li>
        ))}
      </ol>
    </section>
  );
};
